import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import NProgress from 'nprogress'
import { SPR_TOKEN } from '@/constant'
import 'nprogress/nprogress.css'
Vue.use(Router)
const router = new Router({
  routes,
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  let isLogined = !!window.localStorage.getItem(SPR_TOKEN)
  var token = to.query.token
  if (token) {
    const url = `${process.env.LOGIN_URL}/GetUser?token=${token}`
    console.log('token=>', token)
    Vue.$http
      .get(url)
      .then(({ data }) => {
        console.log('data=>', data)
        if (data.success) {
          const userInfo = data.result
          // 获取之前登录记录,如果登录人不同则清除缓存
          let beforeLogin = JSON.parse(
            window.localStorage.getItem('CURRENT_USER')
          )
          if (beforeLogin) {
            // 有登录记录
            if (
              userInfo.customer.customerCode !==
              beforeLogin.customer.customerCode
            ) {
              window.localStorage.clear()
            }
          } else {
            // 无登录记录也清除缓存
            window.localStorage.clear()
          }
          // 保存登录用户信息到缓存
          window.localStorage.setItem(
            'CURRENT_USER',
            JSON.stringify(userInfo)
          )
          window.localStorage.setItem(SPR_TOKEN, userInfo.result)
          console.log('登陆成功')
          console.log('user', data.result)
          if (data.result.isPrimaryAccount) {
            // 如果是主账户跳转到首页
            next(to.path)
          } else {
            var permissions = JSON.parse(data.result.customer.permissions)
            console.log('permissions', permissions)
            console.log('permissions[0]', permissions[0])
            if (permissions) {
              // window.location.href = '#' + permissions[0]
              next(permissions[0])
            } else {
              next()
            }
          }
        } else {
          next('/login')
        }
      })
      .catch((err) => {
        console.log('err=>', err)
        next('/login')
        // Vue.$alert(err.message)
      })
  } else if (isLogined || to.path === '/login') {
    NProgress.start()
    next()
  } else {
    console.log('222=>')
    next('/login')
    setTimeout(() => {
      window.location.reload()
    })
  }
})

router.afterEach((transition) => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js